import {
    Column,
    Container,
    cssVar,
    Grid,
    Header,
    Label,
    PolicyAttention,
    PolicyBind,
    PolicyIssue,
    PolicyQuote,
    PolicyQuoteAccept,
    PolicyRenewal,
    Row,
    Separator,
    useAlignments,
    useSizes,
} from 'metrix-common3';
import { FormattedMessage } from 'react-intl';

import Hero from '../../CommonComponents/Hero';

const ProfileRenewalHeader = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    const renderHeader = (policyStatus) => {
        let icon = null;
        let mainHeader = <FormattedMessage id='Profile_Renewal_Header.renewalReview' />;
        let subHeader = '';
        switch (policyStatus) {
            case 'incomplete':
            case 'submitted':
            case 'accepted':
                icon = <PolicyRenewal />;
                subHeader = <FormattedMessage id='Profile_Renewal_Header.createRenewal' />;
                break;
            case 'quoted':
            case 'quoteIssued':
                icon = <PolicyQuote />;
                subHeader = <FormattedMessage id='Profile_Renewal_Header.createRenewal' />;
                break;
            case 'quoteAccepted':
                icon = <PolicyQuoteAccept />;
                subHeader = <FormattedMessage id='Profile_Renewal_Header.createRenewal' />;
                break;
            case 'rejected':
            case 'abandoned':
            case 'lost':
                icon = <PolicyAttention />;
                break;
            case 'bindRequested':
                icon = <PolicyBind />;
                subHeader = <FormattedMessage id='Profile_Renewal_Header.createRenewal' />;
                break;
            case 'bound':
                icon = <PolicyBind />;
                subHeader = <FormattedMessage id='Profile_Renewal_Header.bound' />;
                break;
            case 'issued':
                mainHeader = <FormattedMessage id='Profile_Renewal_Header.youreAllSet' />;
                subHeader = <FormattedMessage id='Profile_Renewal_Header.renewalPolicy' />;
                icon = <PolicyIssue />;
                break;
            case 'renewal':
                icon = <PolicyQuote />;
                break;
            default:
                icon = <PolicyBind />;
                break;
        }

        return { icon, mainHeader, subHeader };
    };

    const _getDocuments = (type) => {
        let documents = [];
        if (
            props.document?.documents &&
            props.document.documents.length > 0 &&
            props.document.documents.some((x) => x.type === type)
        ) {
            documents = props.document.documents.filter((x) => x.type === type);
        }

        return documents;
    };

    const _isDesktop = props.isDesktop;
    const _isTablet = props.isTablet;
    const isMobile = props.isMobile;

    const _isAdmin = props.context.session.userType === 'administrator';
    const _isBroker = props.context.session.userType === 'broker';
    const isClient = props.context.session.userType === 'client';

    const clientName = props.context.session.firstName;
    const _clientStatus = props.policySummary.status;

    const { icon, mainHeader, subHeader } = renderHeader(props.policySummary.status);

    return (
        <Container>
            {isClient ? (
                <Hero>
                    <Grid>
                        {isMobile ? (
                            <>
                                <Row>
                                    <Column xs={12}>
                                        <Header
                                            color={cssVar.colorLightMode}
                                            size={sizes.xl}
                                            text={
                                                <div>
                                                    <FormattedMessage id='Profile_Renewal_Header.welcome' />
                                                    <span> {clientName}!</span>
                                                </div>
                                            }
                                        />
                                    </Column>
                                </Row>
                                <Row>
                                    <Column xs={12}>
                                        <Label
                                            top={sizes.xs}
                                            left={sizes.sm}
                                            right={sizes.sm}
                                            size={sizes.lg}
                                            color={cssVar.colorLightMode}
                                            text={<FormattedMessage id='Profile_Renewal_Header.subHeader' />}
                                        />
                                    </Column>
                                </Row>
                            </>
                        ) : (
                            <>
                                <Row>
                                    <Column xs={12}>
                                        <Header
                                            color={cssVar.colorLightMode}
                                            size={sizes.xl}
                                            text={
                                                <div>
                                                    <FormattedMessage id='Profile_Renewal_Header.welcome' />
                                                    <span> {clientName}!</span>
                                                </div>
                                            }
                                        />
                                    </Column>
                                </Row>
                                <Row>
                                    <Column>
                                        <Label
                                            top={sizes.md}
                                            left={sizes.xl}
                                            right={sizes.xl}
                                            size={sizes.lg}
                                            color={cssVar.colorLightMode}
                                            text={<FormattedMessage id='Profile_Renewal_Header.subHeader' />}
                                        />
                                    </Column>
                                </Row>
                            </>
                        )}
                    </Grid>
                </Hero>
            ) : (
                <Grid>
                    <Row>
                        <Column>
                            <Container inline top={sizes.xl} horizontalAlignment={alignments.center}>
                                {icon}
                            </Container>
                            <Header size={sizes.xl} top={sizes.sm} bottom={sizes.xs} text={mainHeader} />
                            <Label bottom={sizes.lg} text={subHeader} />
                        </Column>
                    </Row>
                </Grid>
            )}
            <Separator solid top={sizes.xxs} />
        </Container>
    );
};

export default ProfileRenewalHeader;
